import React, { useContext, useEffect, useState } from 'react'
import ModalQueryName from '../../../Inventory/ModalBox/ModalQueryName';
import MyContext from '../../../Inventory/MyContext';
import Loader from '../../../Inventory/Props/Loader';
import AlertBoxError from '../../../Inventory/Props/AlertBoxError';
import Query from '../../../API/APIServices/Query';
import AlertBox from '../../../Inventory/Props/AlertBox';
import TextBox from '../DraggableComponent/TextBox';
// import GlobalSelector from './GlobalSelector'

const ReportDesignSection = (props) => {

    const {
        OpenAlertBox,
        alertBox,
        OpenAlertBoxEdit,
        alertBoxEdit,
        alertBoxError,
        OpenAlertBoxError,
        TemplateData,
        setTemplateData,
        showTemporaryAlert,
        setStylesArray,
        setDroppedItems,
        clickedItemId,
    } = useContext(MyContext);

    const [loading, setLoading] = useState(false);

    const [inputValuesForQuery, setInputValuesForQuery] = useState({
        id: 0,
        title: "",
        query: "",
        query2: "",
        query3: "",
        isActive: true,
    });

    const [QueryData, setQueryData] = useState([]);

    const fetchQueryData = async () => {
        const data = await Query.getQuery1();
        if (data) {
            setQueryData(data);
        } else {
            console.log(data);
        }
    };

    useEffect(() => {
        fetchQueryData();
    }, [])

    const [queryModal, setQueryModal] = useState(false);

    const openQueryModal = () => {
        setQueryModal(true);
    }

    const closeQueryModal = () => {
        fetchQueryData();
        setQueryModal(false);
    }

    const handleModalClick = (e) => {
        e.stopPropagation();
    };

    const handleInputChangeForQuery = (event) => {
        const { name, value } = event.target;
        console.log(`Changing ${name} to ${value}`);

        setInputValuesForQuery((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const SaveQuery = () => {
        setLoading(true);
        const isSuccess = Query.insertQuery(inputValuesForQuery);
        if (isSuccess) {
            OpenAlertBox();
            setLoading(false);
            setInputValuesForQuery({
                title: "",
                query: "",
                query2: "",
                query3: "",
                isActive: true,
            });
            showTemporaryAlert("Your Query is saved");
        } else {
            showTemporaryAlert("Error while Insert");
        }
    };

    const updateQuery = () => {
        setLoading(true);
        const isSuccess = Query.updateQuery(inputValuesForQuery);
        if (isSuccess) {
            OpenAlertBox();
            setLoading(false);
            setInputValuesForQuery({
                id: 0,
                title: "",
                query: "",
                query2: "",
                query3: "",
                isActive: true,
            });
            showTemporaryAlert("Your Query is saved");
        } else {
            showTemporaryAlert("Error while Updating");
        }
    };

    const deleteQuery = () => {
        setLoading(true);
        const isSuccess = Query.deleteQuery(inputValuesForQuery);
        if (isSuccess) {
            OpenAlertBox();
            setLoading(false);
            setInputValuesForQuery({
                id: 0,
                title: "",
                query: "",
                query2: "",
                query3: "",
                isActive: true,
            });
            showTemporaryAlert("Your Query is Deleted");
        } else {
            showTemporaryAlert("error while updating");
        }
    };

    const [fieldName, setFieldName] = useState([]);
    const [sqlQuery, setSqlQuery] = useState()

    const handleQueryDataChange = async (e) => {
        const id = e.target.value;
        var fieldNameData = await Query.getQueryColumnName(id);
        setFieldName(fieldNameData);

        // const queryData = QueryData.find(item => item.id == id);
        // setSqlQuery(queryData?.query)
        setSqlQuery(id);
    }

    const [fieldValue, setFieldValue] = useState();

    const handleFieldNameSelect = (e) => {
        setFieldValue(e.target.value);
    }

    const AddBtnClick = async () => {
        if (fieldValue && fieldValue != '') {
            try {
                setTemplateData(prevState => {
                    if (!prevState.insertQuery) {
                        return {
                            ...prevState,
                            insertQuery: sqlQuery ? sqlQuery : null,
                        };
                    }
                    const isQueryPresent = prevState.insertQuery.includes(sqlQuery);
                    if (!isQueryPresent && sqlQuery) {
                        return {
                            ...prevState,
                            // insertQuery: `${prevState.insertQuery} ; ${sqlQuery}`,
                            insertQuery: `${sqlQuery}`,
                        };
                    } else {
                        return prevState;
                    }
                });
                handleButtonClick();
                localStorage.setItem("VariableName", `@${fieldValue}`)
                await navigator.clipboard.writeText(`@${fieldValue}`);
                console.log('Copied to clipboard: ' + fieldValue);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        } else {
            showTemporaryAlert('Please select a field name.');
        }
    }

    // const [inputValue, setInputValue] = useState('')

    // const handlePaste = async (event) => {
    //     event.preventDefault();
    //     const pastedData = await navigator.clipboard.readText();
    //     if (pastedData.includes('@')) {
    //         setInputValue(pastedData);
    //     } else {
    //         console.log("Paste failed: Pasted content must contain '@'");
    //     }
    // };

    const [showToast, setShowToast] = useState(false);

    const handleButtonClick = () => {
        setShowToast(true);

        setTimeout(() => {
            setShowToast(false);
        }, 500);
    };

    // const AddFieldBtn = () => {
    //     if (fieldValue && fieldValue !== '') {
    //         const newId = `FieldValueComponent-${Date.now()}`; // unique id
    //         const copiedValue = localStorage.getItem("VariableName");
    //         const valueToUse = (copiedValue && copiedValue !== "undefined" && copiedValue !== "null")
    //             ? copiedValue
    //             : fieldValue;

    //         const TEXTBOX_COMPONENT_ID = 39; // <-- Use your actual TextBox componentMap key

    //         const newItem = {
    //             id: newId,
    //             items: [TEXTBOX_COMPONENT_ID],
    //             textContents: valueToUse,
    //             positionX: 50,
    //             positionY: 50,
    //         };
    //         setDroppedItems(prev => [...prev, newItem]);
    //         setStylesArray(prev => [
    //             ...prev,
    //             {
    //                 id: newId,
    //                 style: {
    //                     positionX: 50,
    //                     positionY: 50,
    //                     width: 200,
    //                     height: 50,
    //                 },
    //                 content: valueToUse,
    //             },
    //         ]);
    //         localStorage.removeItem("VariableName");
    //     } else {
    //         showTemporaryAlert("Please select a field name");
    //     }
    // };

    const AddFieldBtn = () => {
        if (fieldValue && fieldValue !== '') {
            const newId = `FieldValueComponent-${Date.now()}`; // unique id
            const copiedValue = localStorage.getItem("VariableName");
            const valueToUse = (copiedValue && copiedValue !== "undefined" && copiedValue !== "null")
                ? copiedValue
                : fieldValue;

            const TEXTBOX_COMPONENT_ID = 39; // TextBox componentMap key

            if (clickedItemId) {
                setDroppedItems(prev => {
                    const selectedItem = prev.find(item => item.id === clickedItemId);
                    if (selectedItem && selectedItem.items && selectedItem.items[0] == 1) {
                        // It's a ColumnOne, append TextBox (no positionX/Y needed)
                        return prev.map(item =>
                            item.id === clickedItemId
                                ? {
                                    ...item,
                                    items: [...item.items, TEXTBOX_COMPONENT_ID],
                                    // textContents: [
                                    //     ...(Array.isArray(item.textContents) ? item.textContents : []),
                                    //     valueToUse
                                    // ]
                                    textContents: valueToUse
                                }
                                : item,
                        );
                    } else {
                        // Not a ColumnOne, add as new item at the end (with position)
                        return [
                            ...prev,
                            {
                                id: newId,
                                items: [TEXTBOX_COMPONENT_ID],
                                textContents: valueToUse,
                                positionX: 50,
                                positionY: 50,
                            }
                        ];
                    }
                });
                setStylesArray(prev => [
                    ...prev,
                    {
                        id: newId,
                        style: {
                            positionX: 50,
                            positionY: 50,
                            width: 200,
                            height: 50,
                        },
                        content: valueToUse,
                        textContents: valueToUse,
                    },
                ]);
            } else {
                // No component selected, add as new item at the end (with position)
                setDroppedItems(prev => [
                    ...prev,
                    {
                        id: newId,
                        items: [TEXTBOX_COMPONENT_ID],
                        textContents: valueToUse,
                        positionX: 50,
                        positionY: 50,
                    }
                ]);
                setStylesArray(prev => [
                    ...prev,
                    {
                        id: newId,
                        style: {
                            positionX: 50,
                            positionY: 50,
                            width: 200,
                            height: 50,
                        },
                        content: valueToUse,
                        textContents: valueToUse,
                    },
                ]);
            }
            localStorage.removeItem("VariableName");
        } else {
            showTemporaryAlert("Please select a field name");
        }
    };

    return (
        <div className="flex-container">
            <div className="flex-contparent">
                <div className="typography-sectionoption">
                    <p className="general-paragraph" style={{ marginBottom: "0px" }}>Query Name</p>
                    <div className='flex-start'>
                        <select name="display" className='selectorstyle height-33'
                            onChange={handleQueryDataChange}>
                            <option value="0">Select</option>
                            {QueryData && QueryData.map((data) => (
                                <option value={data.id} key={data.id}>{data.title}</option>
                            ))}
                        </select>
                        <button className="edit_component_btn" onClick={openQueryModal}>Query Build</button>
                    </div>
                </div>
            </div>
            <div className="flex-contparent mt-2">
                <div className="typography-sectionoption">
                    <p className="general-paragraph" style={{ marginBottom: "0px" }}>Field Name</p>
                    <div className='flex-start'>
                        <select name="display" className='selectorstyle height-33' onChange={handleFieldNameSelect}>
                            <option value="0"></option>
                            {fieldName && fieldName.map((data, index) => (
                                <option value={data} key={index}>{data}</option>
                            ))}
                        </select>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                        <button className="edit_component_btn" onClick={AddBtnClick}>Copy Variable</button>
                        <button className="edit_component_btn" onClick={AddFieldBtn} style={{ marginLeft: "10px" }}>Add field</button>
                    </div>
                    {showToast && (
                        <div className="toastDiv-webTemplate" >
                            Copied
                        </div>
                    )}
                </div>
            </div>

            {/* <div className="flex-flex-parent">
                <p className="general-paragraph">Test</p>
                <input type="text" className='flex-input' onClick={handlePaste} onChange={(e) => setInputValue(e.target.value)} value={inputValue} />
            </div> */}

            {/************************* Query Builder Modal *****************************/}
            {queryModal && (
                <div className="modal-back" onClick={closeQueryModal}>
                    <div onClick={handleModalClick} className="partyDetailPosModal" style={{ height: "auto", width: "35%" }}>
                        <div style={{ padding: "15px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <label style={{ fontWeight: "600", color: "black", fontSize: "18px" }}>QUERY BUILDER</label>
                                <label style={{ cursor: "pointer", fontSize: "24px", alignItems: "baseline", fontWeight: "600" }} onClick={closeQueryModal}>x</label>
                            </div>
                            <hr />
                            <div style={{ margin: "10px", padding: "0px 10px" }}>
                                <ModalQueryName
                                    SaveQuery={SaveQuery}
                                    handleInputChangeForQuery={handleInputChangeForQuery}
                                    inputValuesForQuery={inputValuesForQuery}
                                    setInputValuesForQuery={setInputValuesForQuery}
                                    updateQuery={updateQuery}
                                    deleteQuery={deleteQuery}
                                    closeModal={closeQueryModal} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* ************************************************************************ */}
            {alertBoxEdit && (
                <AlertBox
                    HeadingTop="Updated"
                    Heading="Your Item Master is Updated"
                    onYesClick={OpenAlertBoxEdit}
                    singleButton={true}
                    OpenAlertBox={OpenAlertBoxEdit}
                />
            )}

            {alertBoxError && (
                <AlertBoxError
                    HeadingTop="ERROR"
                    Heading="Error While Updating Data"
                    onYesClick={OpenAlertBoxError}
                    singleButton={true}
                    OpenAlertBox={OpenAlertBoxError}
                />
            )}
            {loading && <Loader />}
        </div>
    )
}

export default ReportDesignSection
